<template>
  <div id="app">
    <header style="position: fixed;z-index: 1000;width: 100%;" >
      <!-- <navHeader ref=navHeader></navHeader> -->
    </header>
 
    <div class="banner">
      <!-- <img class="banner_bg" src="./images/banner.png" alt=""> -->
      <div class="banner_left">
        <p style="height: 74px;" class="banner_title"></p>
        <p class="banner_title">大救星全球救援服务</p>
        <div class="banner_left_type">
          <span>救援</span>
          <span>救治</span>
          <span>救助</span>
          <span>救护</span>
        </div>
        <div class="experience">
          <!-- 立即体验
          <img src="./images/youjiantou.png" alt=""> -->
        </div>
        <div class="video_box">
          <div class="video" @click="clickVideo(1)">
            <span>视频1</span>
            <img src="./images/vid-01.png" alt="">
            <img style="width: 3vw;height: 3vw;position: absolute;left: 50%;top: 50%;margin-left: -1.5vw;margin-top: -1.5vw;" src="./images/bf.png" alt="">
            <p>两分钟了解大救星</p>
          </div>
          <div class="video" @click="clickVideo(2)">
            <span>视频2</span>
            <img src="./images/vid-01.png" alt="">
            <img style="width: 3vw;height: 3vw;position: absolute;left: 50%;top: 50%;margin-left: -1.5vw;margin-top: -1.5vw;" src="./images/bf.png" alt="">
            <p>大救星“一键呼救”</p>
          </div>
          <!-- <div class="video" @click="clickVideo">
            <span>视频3</span>
            <img src="./images/vid-03.png" alt="">
            <p>点击观看</p>
          </div> -->
        </div>
      </div>

      <div class="banner_right">
        <div class="banner_right_item">
          <div class="text textLeft">
            多款多场景救援+保险解决方案供您选择
          </div>
          <!-- <img src="./images/left-top.png" alt=""> -->
        </div>

        <div class="banner_right_item">
          <!-- <img src="./images/left-bottom.png" alt=""> -->
          <div class="text textLeft">
            24小时智能云平台实时数据跟进
          </div>
        </div>

        <div class="banner_right_item">
          <!-- <img src="./images/right-top.png" alt=""> -->
          <div class="text textRight">
            全球范围服务资源为您保驾护航
          </div>
        </div>

        <div class="banner_right_item">
          <!-- <img src="./images/right-bottom.png" alt=""> -->
          <div class="text textRight">
            <span>5秒</span>
            一键救援功能即刻服务
          </div>
        </div>
      </div>
      <!-- <div class="banner_bottom">
        <div class="xiahua" @click="next()">
          <div style="text-align: center;"><img style="width: 30px;" class="banner_bg" src="./img/slidedownward.png" alt=""></div>
          <div>向下滑动</div>
        </div>
        
      </div> -->
    
    </div>
    <!-- 服务领域 -->
    <div class="service home-content" style="margin:55px auto 0;">
      <div class="title">
        <img src="./images/yinghao.png" alt="">
        <span><b>服务领域</b></span>
      </div>
      <div class="service-list" style="margin-top:5vw">
          <div>
            <div>
              <img style="width: 6vw;" src="./img/Servicearea1.png" alt="">
            </div>
            <div class="service-description">
                <div><b style="font-size:20px">出行救援</b></div>
                <div  style="width: 54px;height: 6px;background: #4FADFA;border-radius: 3px;margin:10px 0px"></div>
                <div style="line-height: 30px;font-size: 0.9vw;width:100%;height: 75px;">平台搭建了覆盖全球的救援服务资源网络，含战乱及受经济制裁地区。可为用户提供包含紧急医疗转运、医疗送返、医疗垫付、安排亲友探望、遗体/骨灰送返在内的各类救援服务。</div>
            </div>
          </div>
           <div>
            <div>
              <img style="width: 6vw;" src="./img/Servicearea2.png" alt="">
            </div>
            <div class="service-description">
                <div><b style="font-size:20px">星使服务</b></div>
                <div style="width: 54px;height: 6px;background: #4FADFA;border-radius: 3px;margin:10px 0px"></div>
                <div style="line-height: 30px;font-size: 0.9vw;width:100%;height: 75px;">平台在全球招募有3000余名双语星使，可为用户提供包含陪同就医、陪同翻译、接送机在内的各类陪同代办服务，解决用户境外出行时因语言不通、文化差异带来的诸多不便。</div>
            </div>
          </div>
          <div>
            <div>
              <img style="width: 6vw;" src="./img/Servicearea3.png" alt="">
            </div>
            <div class="service-description">
                <div><b style="font-size:20px">生活服务</b></div>
                <div style="width: 54px;height: 6px;background: #4FADFA;border-radius: 3px;margin:10px 0px"></div>
                <div style="line-height: 30px;font-size: 0.9vw;width:100%;height: 105px;">致力于解决用户家居生活中所遇到的各类难题，依靠丰富的资源，平台可提供全国范围的紧急开锁、管道疏通、家政保洁、家电清洗等生活服务。</div>
            </div>
          </div>
          <div>
            <div>
              <img style="width: 6vw;" src="./img/Servicearea4.png" alt="">
            </div>
            <div class="service-description">
                <div><b style="font-size:20px">急诊绿通</b></div>
                <div style="width: 54px;height: 6px;background: #4FADFA;border-radius: 3px;margin:10px 0px"></div>
                <div style="line-height: 30px;font-size: 0.9vw;width:100%;height: 105px;">通过对医疗服务资源的整合，平台资源网络现已全面覆盖国内县级以上城市。可为用户提供包括日常诊疗咨询、诊前、诊中、院中、院后环节在内的全流程一站式综合服务。</div>
            </div>
          </div>
          <div>
            <div>
              <img style="width: 6vw;" src="./img/Servicearea5.png" alt="">
            </div>
            <div class="service-description">
                <div><b style="font-size:20px">在线医生</b></div>
                <div style="width: 54px;height: 6px;background: #4FADFA;border-radius: 3px;margin:10px 0px"></div>
                <div style="line-height: 30px;font-size: 0.9vw;width:100%;height: 105px;">平台建立了由来自公立医院且具备多年临床经验的执业医师组成的全科医师团队，可为国内客户提供7*24小时的一对一在线咨询服务，支持图文、电话或视频等形式。</div>
            </div>
          </div>
      </div>
    </div>
     <!-- 四救服务：按图片实际比例撑开高度，避免与下一模块重叠。 -->
    <div class="advantage home-content" style="height: auto;margin: 55px auto 0px;">
      <div class="advantage-content" style="width:100%">
        <div class="title" style="padding: 3vw 0vw 7vw 0px;">
          <img src="./images/yinghao.png" alt="">
          <span><b>四救服务</b></span>
        </div>
        <div style="text-align: center;position: relative;">
          <img style="width: 100%;" src="./img/sjfw-hd.png" alt="">
         
        </div>
      </div>

    </div>
     <!-- 服务特色 -->
    <div class="advantage" style="background-color: #f6f7f7;height: 37vw;">
      <div class="advantage-content home-content">
        <div class="title" style="padding: 5vw 0px;">
          <img src="./images/yinghao.png" alt="">
          <span><b>服务特色</b></span>
        </div>
        <div class="characteristic-list">
           <div class="characteristic1" @mouseenter="handleEnter(1)" @mouseleave="handleLeave(0)">
              <div style="font-size: 1vw;font-family: Microsoft YaHei;font-weight: 400;margin-left: 2vh;padding-top: 55px;"><b style="color: #FFFFFF;">突破传统救援限制</b></div>
              <div :class="{act:act == 1}" style="width: 5vh;height:0.35vw;background: #FFFFFF;border-radius: 4px;margin-left: 2vh;margin-top:2vw;margin-bottom: 2.5vw;transition: 0.3s all ease;"></div>
              <div style="color: #FFFFFF;font-size: 0.8vw;font-family: Microsoft YaHei;font-weight: 400;line-height: 1.5vw;padding: 0px 2vh;">大救星救援服务无用户年龄限制、无既往病史限制、无风险运动限制、无地理区域限制、无救援次数限制、无救援额度限制。</div>
           </div>
            <div class="characteristic2"  @mouseenter="handleEnter(2)" @mouseleave="handleLeave(0)">
              <div style="font-size: 1vw;font-family: Microsoft YaHei;font-weight: 400;margin-left: 2vh;padding-top: 55px;"><b style="color: #FFFFFF;">独创星使服务模式</b></div>
              <div :class="{act:act == 2}"  style="width: 5vh;height:0.35vw;background: #FFFFFF;border-radius: 4px;margin-left: 2vh;margin-top:2vw;margin-bottom: 2.5vw;transition: 0.3s all ease;"></div>
              <div style="color: #FFFFFF;font-size: 0.8vw;font-family: Microsoft YaHei;font-weight: 400;line-height: 1.5vw;padding: 0px 2vh;">平台在全球招募有可熟练使用中文及当地语言的“大救星星使”，可为用户提供陪同、代办等各类贴心服务。</div>
           </div>
           <div class="characteristic3"  @mouseenter="handleEnter(3)" @mouseleave="handleLeave(0)">
              <div style="font-size: 1vw;font-family: Microsoft YaHei;font-weight: 400;margin-left: 2vh;padding-top: 55px;"><b style="color: #FFFFFF;">一键救援快速报案</b></div>
              <div :class="{act:act == 3}" style="width: 5vh;height:0.35vw;background: #FFFFFF;border-radius: 4px;margin-left: 2vh;margin-top:2vw;margin-bottom: 2.5vw;transition: 0.3s all ease;"></div>
              <div style="color: #FFFFFF;font-size: 0.8vw;font-family: Microsoft YaHei;font-weight: 400;line-height: 1.5vw;padding: 0px 2vh;">用户可通过大救星APP或小程序首页的“一键救援”按键直接发起呼救，救援人员365天*24小时不间断待命。</div>
              <!-- <div style="color: #FFFFFF;font-size: 0.8vw;font-family: Microsoft YaHei;font-weight: 400;line-height: 1.5vw;padding: 0px 2vh;">用户可通过大救星小程序首页的“一键救援”按键直接发起呼救，救援人员365天*24小时不间断待命。</div> -->
           </div>
           <div class="characteristic4"  @mouseenter="handleEnter(4)" @mouseleave="handleLeave(0)">
              <div style="font-size: 1vw;font-family: Microsoft YaHei;font-weight: 400; margin-left: 2vh;padding-top: 55px;"><b style="color: #FFFFFF;">全球救援出行无忧</b></div>
              <div :class="{act:act == 4}" style="width: 5vh;height:0.35vw;background: #FFFFFF;border-radius: 4px;margin-left: 2vh;margin-top:2vw;margin-bottom: 2.5vw;transition: 0.3s all ease;"></div>
              <div style="color: #FFFFFF;font-size: 0.8vw;font-family: Microsoft YaHei;font-weight: 400;line-height: 1.5vw;padding: 0px 2vh;">大救星救援服务网络覆盖全球233个国家和地区，含战乱及受经济制裁的国家和地区。</div>
           </div>
           <div class="characteristic5"  @mouseenter="handleEnter(5)" @mouseleave="handleLeave(0)">
              <div style="font-size: 1vw;font-family: Microsoft YaHei;font-weight: 400;margin-left: 2vh;padding-top: 55px;"><b style="color: #FFFFFF;">有求必救不设门槛</b></div>
              <div :class="{act:act == 5}" style="width: 5vh;height:0.35vw;background: #FFFFFF;border-radius: 4px;margin-left: 2vh;margin-top:2vw;margin-bottom: 2.5vw;transition: 0.3s all ease;"></div>
              <div style="color: #FFFFFF;font-size: 0.8vw;font-family: Microsoft YaHei;font-weight: 400;line-height: 1.5vw;padding: 0px 2vh;">无论是否购买了大救星产品，都可向大救星发起呼救，并获得相应的救援、救助服务。</div>
           </div>
        </div>
      </div>

    </div>
    <!-- 服务资源 -->
   <div class="advantage" style="height: 47vw;margin-top: 70px;">
     <div class="advantage-content home-content">
       <div class="title">
         <img src="./images/yinghao.png" alt="">
         <span><b>服务资源</b></span>
       </div>
       <div class="resourcesbg" style="margin-top:5vw;">
           <div style="text-align: center;position: relative;">
            <!-- <img style="position: absolute;left: 0px;z-index: 1;width:100%" src="./img/zxy.png" alt=""> -->
            <!-- 资源标签在统一内容区内左右定位，底行留出图标空间，避免越界或相互遮挡。 -->
            <div style="position: absolute;top:2vw;left: 0;z-index: 11;width: 100%;">
              
                <div style="width: 23vw;height: 3vw;background: #FFFFFF;border: 1px solid #E3E7ED;box-shadow: 0px 3px 13px 0px rgba(50,72,183,0.11);border-radius: 10px;position: absolute;top: 0px;left: 0;">
                <div style="line-height: 3vw;font-size: 1vw">
                  <img style="position: absolute;right: -1.5vw;width: 3vw;" src="./img/fwzy1.png" alt="">
                  星使覆盖<b style="margin-left:2vw;color: #4E8DFA;font-size: 1vw">138个国家和地区</b></div>
                </div>
                <div style="width: 23vw;height: 3vw;background: #FFFFFF;border: 1px solid #E3E7ED;box-shadow: 0px 3px 13px 0px rgba(50,72,183,0.11);border-radius: 10px;margin-left: 32vh;position: absolute;right: 0;">
                <div style="line-height: 3vw;font-size: 1vw"> <img style="position: absolute;left: -1.5vw;width: 3vw;" src="./img/fwzy1.png" alt="">服务范围<b style="margin-left:2vw;color: #4E8DFA;font-size: 1vw">全球</b></div>
                </div>
                <div style="width: 26vw;height: 3vw;background: #FFFFFF;border: 1px solid #E3E7ED;box-shadow: 0px 3px 13px 0px rgba(50,72,183,0.11);border-radius: 10px;position: absolute;left: 0;top: 7.5vw;">
                <div style="line-height: 3vw;font-size: 1vw"> <img style="position: absolute;right: -1.5vw;width: 3vw;" src="./img/fwzy1.png" alt="">星使覆盖城市<b style="margin-left:2vw;color: #4E8DFA;font-size: 1vw">820个 (境外583,境内237)</b></div>
                </div>
                <div style="width: 28vw;height: 3vw;background: #FFFFFF;border: 1px solid #E3E7ED;box-shadow: 0px 3px 13px 0px rgba(50,72,183,0.11);border-radius: 10px;position: absolute;right: 0;top: 14.5vw;">
                <div style="line-height: 3vw;font-size: 1vw"> <img style="position: absolute;left: -1.5vw;width: 3vw;" src="./img/fwzy1.png" alt="">签约服务商<b style="margin-left:2vw;color: #4E8DFA;font-size: 1vw">{{instiCount}} 家</b></div>
                </div>
                <div style="width: 28vw;height: 3vw;background: #FFFFFF;border: 1px solid #E3E7ED;box-shadow: 0px 3px 13px 0px rgba(50,72,183,0.11);border-radius: 10px;position: absolute;left: 0;top: 14.5vw;">
                <div style="line-height: 3vw;font-size: 1vw"> <img style="position: absolute;right: -1.5vw;width: 3vw;" src="./img/fwzy1.png" alt="">境内服务体系<b style="margin-left:2vw;color: #4E8DFA;font-size: 1vw">7位海外代表+服务商+海外星使</b></div>
                </div>
                <div style="width: 26vw;height: 3vw;background: #FFFFFF;border: 1px solid #E3E7ED;box-shadow: 0px 3px 13px 0px rgba(50,72,183,0.11);border-radius: 10px;position: absolute;right: 0;top: 7.5vw;">
                <div style="line-height: 3vw;font-size: 1vw"> <img style="position: absolute;left: -1.5vw;width: 3vw;" src="./img/fwzy1.png" alt="">服务网点<b style="margin-left:2vw;color: #4E8DFA;font-size: 1vw">60余万家</b></div>
                </div>
                <div style="width: 33vw;height: 3vw;background: #FFFFFF;border: 1px solid #E3E7ED;box-shadow: 0px 3px 13px 0px rgba(50,72,183,0.11);border-radius: 10px;position: absolute;left: 0;top: 22vw;">
                <div style="line-height: 3vw;font-size: 1vw"> <img style="position: absolute;right: -1.5vw;width: 3vw;" src="./img/fwzy1.png" alt="">境外服务体系<b style="margin-left:2vw;color: #4E8DFA;font-size: 1vw">145家机构+34家调处中心+服务商+星使</b></div>
                </div>
                <div style="width: 33vw;height: 3vw;background: #FFFFFF;border: 1px solid #E3E7ED;box-shadow: 0px 3px 13px 0px rgba(50,72,183,0.11);border-radius: 10px;position: absolute;right: 0;top: 22vw;">
                <div style="line-height: 3vw;font-size: 1vw"> <img style="position: absolute;left: -1.5vw;width: 3vw;" src="./img/fwzy1.png" alt="">双语星使<b style="margin-left:2vw;color: #4E8DFA;font-size: 1vw">{{providerCount}} 人</b></div>
                </div>
            </div>
           
           </div>
           
       </div>
     </div>

   </div>
    <!-- 服务产品 -->
    <div class="product home-content">
      <div class="title">
        <img src="./images/yinghao.png" alt="">
        <span><b>服务产品</b></span>
      </div>

      <div class="navTab">
        <div @click="clickProduct(index)" class="navTab-item" :class="productNum == index?'navTabOnly':''"
          v-for="(item,index) in fwcplist" :key="index">
          {{ item.name }}
        </div>
      </div>
       <div v-if="productNum == 0">
        <div class="product_box">
          <div class="product-item" ref="productDom" v-for="(item,index) in productList" :key="index" @mouseover="mouseOver(index)"
            @mouseleave="mouseLeave(index)">
            <div v-if="productIndex!= index">
              <div class="product_name"><b style="color:#FFFFFF">{{item.groupName}}</b></div>
              <div class="product_price">￥<span>{{item.money/100}}</span>/元</div>
              <div class="product_info">
                了解更多
                <img style="margin-left:8px" src="./images/check.png" alt="">
              </div>
              <img class="bg-img" v-if="productIndex != index" :src="item.url" alt="">
            </div>
          
            <div class="product_hover" v-else>
              <div class="product_left">
                <div class="product_title">{{item.title}}</div>
                <div >
                  <div class="product_name" style="margin-bottom:2vw"><b style="color:#FFFFFF">{{item.groupName}}</b></div>
                  <!-- <div>
                    > 专为商务人士打造的境外旅行保险
                  </div>
                  <div>
                    > 意外身故最高保额50万
                  </div>
                  <div>
                    > 意外身故最高保额50万
                  </div> -->
                </div>
                <div class="introduce">
                  <div>
                    <span class="yuan"></span>
                    <span class="name">服务周期：</span>{{ item.time }}
                  </div>
                  <div>
                    <span class="yuan"></span>
                    <span class="name">服务范围：</span>{{ JSON.parse(item.extraInfo).rescueScope }}
                  </div>
                  <div>
                    <span class="yuan"></span>
                    <span class="name">适用人群：</span>{{ item.des }}
                  </div>
                </div>
              </div>
              <div class="product_right">
                
          
                <div style="margin: 10px;" class="right_price">￥<span>{{item.money/100}}</span>/元</div>
                <vue-qr style="width:5.5vw" v-if="item.productLevel == 0" :text="'https://api.dajiuxing.com.cn/djxh5/#/introduceProduct?name=text&subChannelId=8766&channelId=2011&t=fx&group=' + item.group" :margin="0" :logoSrc="logoSrc" ></vue-qr>
                <vue-qr style="width:5.5vw" v-if="item.productLevel == 2" :text="'https://api.dajiuxing.com.cn/djxh5/#/productPurchase?name=text&subChannelId=8766&channelId=2011&t=fx&test=test&group=' + item.group + '&productCode=' + item.productCode" :margin="0" :logoSrc="logoSrc" ></vue-qr>
                <div class="right_info">
                  扫码了解详情
                  <!-- <img src="./images/check2.png" alt=""> -->
                </div>
              </div>

            </div>
          </div>
          <div v-if="productList.length == 2 || productList.length == 5" style="width:var(--product-card-width);" ref="productDom" v-for="(item,index) in 1" :key="index">
            <div v-if="productIndex!= index">
              <div class="product_name"></div>
              <div class="product_price"></div>
              <div class="product_info">
                
                <img src="./images/check.png" alt="">
              </div>
              <!-- <img class="bg-img" v-if="productIndex != index" :src="item.url" alt=""> -->
            </div>
          
            <div class="product_hover" v-else>
              <div class="product_left">
                <div class="product_title">{{item.title}}</div>
                <div class="product_type">
                  <!-- <div>
                    > 专为商务人士打造的境外旅行保险
                  </div>
                  <div>
                    > 意外身故最高保额50万
                  </div>
                  <div>
                    > 意外身故最高保额50万
                  </div> -->
                </div>
                
              </div>
              

            </div>
          </div>
        </div>
        <div style="text-align: center;" v-if="yiqianYuList.length > 6">
          <img v-if="prodectPagenumber != 1" src="./images/left-2.png" alt="" @click="leftClick()">
          <img v-else src="./images/left-1.png" alt="">
          <img v-if="prodectPagenumber != prodectListLength" src="./images/right-1.png" alt="" @click="rightClick()">
          <img v-else src="./images/right-2.png" alt="">
        </div>
        <div style="text-align: center;height: 40vw;" v-else></div>
       </div>
       <div v-if="productNum == 1">
         <div style="margin-top:50px;position: relative;">
          <img style="width:100%;" src="./img/jyfw.png" alt="">
          <div style="width: 63%;height: 100%;position: absolute;top: 0px;right: 0px;padding-top: 4vw;padding-left: 3vw;">
               <div style="font-size: 1.5vw;">大救星全球救援服务主要分为三大类</div>
               <div style="width:95%;line-height: 1.8vw;font-size: 0.9vw;color: #666666;"><br><b>第一大类：</b>是为客户提供医疗救援，商旅援助等综合服务，包含但不限于紧急医疗转运，医疗送返，医疗费用垫付/担保，接送机等；<br><b>第二大类：</b>是围绕社区，家庭提供的救护及救助服务，例如家庭维保服务，家政保洁，老人看护等；<br><b>第三大类：</b>是围绕“实用，合规”，根据客户的个性化需求，可定制所需的救援服务产品及设备等</div>
          </div>
         </div>
       </div> 
       <div v-if="productNum == 2">
        <div style="margin-top:50px;position: relative;">
          <img style="width:100%;height: 100%;" src="./img/jkjcbg.png" alt="">
          <img style="position: absolute;left: 8%;top: 18%;width: 41%;" src="./img/jkjc.png" alt="">
          <div style="width: 50%;height: 12%;background: rgb(31, 172, 94);border-radius: 54px;position: absolute;left: 4%;top: 73%;font-family: Microsoft YaHei;font-weight: 400;
font-size: 2vh;
color: #FFFFFF;
padding: 1.5%;">
            
            致力于为用户提供最先进的健康监测技术和解决方案，实现健康生活目标。服务内容包括：
          </div>
          <div style="width: 63%;height: 100%;position: absolute;top: 0px;right: 0px;padding-top: 5%;padding-left: 20%;padding-right: 3%;">
             <div style="height: 16.5%;">
              <div style="display: flex;align-items: center;">
                <img style="margin-right: 1%;" src="./img/slcsjc.png" alt="">
                <div class="titlebg"><b>生理参数监测:</b></div>
              </div>
              <div style="font-family: Microsoft YaHei;font-weight: 400;color: rgb(102, 102, 102);line-height: 200%;margin-top: 2%;font-size: 1.5vh;">
                实时监测和记录您的血压、心率、体温、血氧等关键生理参数，让您随时了解自己的身体状况。
              </div>
            </div>
            <div style="height: 16.5%;margin-top:2%">
              <div style="display: flex;align-items: center;">
                <img style="margin-right: 1%;" src="./img/ydyysgl.png" alt="">
                <div class="titlebg"><b>运动与饮食管理:</b></div>
              </div>
              <div style="font-family: Microsoft YaHei;font-weight: 400;color: rgb(102, 102, 102);line-height: 200%;margin-top: 2%;font-size: 1.5vh;">
                通过记录和分析您的运动和饮食数据，帮助您制定科学合理的运动和饮食计划，促进身体健康。
              </div>
            </div>
            <div style="height: 16.5%;margin-top:2%">
              <div style="display: flex;align-items: center;">
                <img style="margin-right: 1%;" src="./img/smzljc.png" alt="">
                <div class="titlebg"><b>睡眠质量监测:</b></div>
              </div>
              <div style="font-family: Microsoft YaHei;font-weight: 400;color: rgb(102, 102, 102);line-height: 200%;margin-top: 2%;font-size: 1.5vh;">
                全面评估您的睡眠质量，分析睡眠问题并给出改善建议，提高您的睡眠质量和生活质量。
              </div>
            </div>
            <div style="height: 16.5%;margin-top:2%">
              <div style="display: flex;align-items: center;">
                <img style="margin-right: 1%;" src="./img/xljkgh.png" alt="">
                <div class="titlebg"><b>心理健康关怀:</b></div>
              </div>
              <div style="font-family: Microsoft YaHei;font-weight: 400;color: rgb(102, 102, 102);line-height: 200%;margin-top: 2%;font-size: 1.5vh;">
                提供专业的心理健康测评和咨询服务，帮助您缓解压力、提升心理健康水平。
              </div>
            </div>
            <div style="height: 16.5%;margin-top:2%">
              <div style="display: flex;align-items: center;">
                <img style="margin-right: 1%;" src="./img/gxhjkjy.png" alt="">
                <div class="titlebg"><b>个性化健康建议:</b></div>
              </div>
              <div style="font-family: Microsoft YaHei;font-weight: 400;color: rgb(102, 102, 102);line-height: 200%;margin-top: 2%;font-size: 1.5vh;">
                根据您的个人情况和监测数据，提供个性化的健康建议和解决方案，让您轻松实现健康目标。
              </div>
            </div>
          </div>
         </div>
       </div> 
       <div v-if="productNum == 3">
        <div style="margin-top:50px;position: relative;">
          <img style="width:100%;" src="./img/jkgl.png" alt="">
          <div style="width: 63%;height: 100%;position: absolute;top: 0px;right: 0px;padding-top: 2.5vw;padding-left: 3vw;">
               <div style="font-size: 1.5vw;padding-left: 3vh;">健康管理主要指涉及健康管理的相关服务</div>
               <div style="width:95%;line-height: 1.8vw;font-size: 0.9vw;color: #666666;padding-left: 3vh;">
                <br>致力于为用户提供全方位、高品质的医疗服务和解决方案。
                <br>平台汇聚了世界各地富有经验的医疗专家、最前沿的医疗技术和服务，可为患者提供个性化的诊疗和护理。
                <br>服务涵盖了预防保健、诊疗、康复等多个领域，致力于为患者提供全面、高效的医疗服务。无论您需要何种医疗需求，我们都能为您提供专业的建议和支持。
                <br>大救星秉承以“患者为中心，以技术为驱动”的人本理念，为创造更美好的健康未来而不懈努力。
              </div>
              </div>
         </div>
       </div> 
    </div>
      <!-- 移动端工具 -->
    <div class="tool-box">
      <div class="title">
        <img src="./images/yinghao.png" alt="">
        <span><b>移动端工具</b></span>
      </div>
      <div class="tool home-content">
        <div class="text">
          大救星是一款帮助解决中国公民海外出行遇到各类问题的APP。核心“一键呼救”，1分钟内响应，处理突发救援事件，通过为用户提供出行目的地精通当地风土人情的星使服务者，
          解决用户和服务者之间的供需关系。
        </div>
        <div class="img-btn">
          <div class="img">
            <img src="./images/app.jpg" alt="">
          </div>
          <div class="btn">APP下载</div>
        </div>
        <div class="text">
          依托微信小程序生态，为用户提供便捷的服务工具，可以随时使用“一键呼救”，
          了解大救星的救援服务产品及在线购买。
        </div>
        <div class="img-btn">
          <div class="img">
            <img src="./images/wx.jpg" alt="">
          </div>
          <div class="btn">小程序</div>
        </div>
      </div>
    </div>   
     <!-- 案例分享 -->
    <div class="caseShare home-content">
      <div class="title">
        <img src="./images/yinghao.png" alt="">
        <span><b>案例分享</b></span>
      </div>
      <div class="caseShare-box">
        <div class="caseShare-item" ref="caseShareDmo" v-for="(item,index) in caseDataList" :key="index" @mouseover="caseShareOver(index)"
          @mouseleave="caseShareLeave(index)"  :style="{background: 'url(' + item.pic + ') no-repeat top right', backgroundSize: '100% 100%'}"  @click="gocasedetail(item.id,item)">
          <!--  -->
          <!-- <img   :src="item.icon" alt=""> -->
          <div style="position: absolute;z-index: 10;background-color: rgba(0,0,0,.3);width: 100%;height: 100%;"></div>
          <div class="case_icon" :class="caseShareIndex==index?'case-hover-icon':''">  </div>
          <span class="case_naem" :class="caseShareIndex==index?'case-hover-name':''" >{{item.title}}</span>
          <div class="bgc" v-if="caseShareIndex == index">
            <div class="ledgement"></div>
            <div class="type" :class="caseShareIndex==index?'case-hover-type':''">{{item.dissect}}</div>
          </div>

        </div>
      </div>
    </div>
       <!-- 平台系统 -->
    <div style="width: 100%;height: 40vw;padding: 0px 15vw;background-color: #f6f7f7;" class="caseShare">
      <div class="title" style="padding-top:70px;height: ;">
        <img src="./images/yinghao.png" alt="">
        <span><b>平台系统</b></span>
      </div>
      <div class="caseShare-box" style="margin-top: 60px;">
        <div style="width:25%;position: relative;height: 22vw;">
          <img style="position: absolute;top:0px;width:100%" src="./img/business1.png" alt="">
           <div class="businessdiv">
             智能产品管理系统
          </div>
        </div>
        <div style="width:25%;position: relative;height: 22vw;">
          <img style="position: absolute;top:0px;width:100%" src="./img/business2.png" alt="">
           <div class="businessdiv">
            智能救援云平台
          </div>
        </div>
        <div style="width:25%;position: relative;height: 22vw;">
          <img style="position: absolute;top:0px;width:100%" src="./img/business3.png" alt="">
           <div class="businessdiv">
            健康管理云平台
          </div>
        </div>
        <div style="width:25%;position: relative;height: 22vw;">
          <img style="position: absolute;top:0px;width:100%" src="./img/business4.png" alt="">
           <div class="businessdiv">
            全球救援指挥云平台
          </div>
        </div>
      </div>
    </div>
       <!-- 国家软件专著权 -->
    <!-- <div style="width: 100%;height: 603px;padding: 0px 15vw;background-color: #f6f7f7;margin-top: 0px;"  class="caseShare">
      <div class="title">
        <h1 style="font-size: 70px;color:#E8E8E8;background-image: -webkit-gradient(linear, 0 0, 0 bottom, from(#E8E8E8), to(#F6F7F7));-webkit-background-clip: text;-webkit-text-fill-color: transparent;">国家软件专著权</h1>
      </div>
      <div class="caseShare-box" style="margin-top: 15vh;">
        <div style="width:100%">
          <div class="zs">
            <h2>企业单位类5项</h2>
          </div>
          <div class="zs">
            <h2>健康服务类13项</h2>
          </div>
          <div class="zs">
            <h2>医疗保障类7项</h2>
          </div>
          <div class="zs">
            <h2>医疗机构类8项</h2>
          </div>
        </div>
        <div style="width:100%">
          <div class="zs">
            <h2>健康干预类3项</h2>
          </div>
          <div class="zs">
            <h2>慢性管理类2项</h2>
          </div>
          <div class="zs">
            <h2>医疗数据类4项</h2>
          </div>
          <div class="zs">
            <h2>保险公司类4项</h2>
          </div>
        </div>
      </div>
    </div>   -->
    <!-- 最新动态 -->
    <div class="about home-content">
      <div class="title">
        <img src="./images/yinghao.png" alt="">
        <span><b>最新动态</b></span>
        <div style="width: 6vw;height: 2vw;border: 1px solid rgb(216, 216, 216);border-radius: 6px;font-size: 1vw;line-height: 2vw;position: absolute;right: 0px;top: 0px;" @click="gonewslist()">查看更多</div>
      </div>
      <div class="about-box">
        <div class="about-img" @click="gonewsdetail(aboutList[0].id,aboutList[0])" >
          <img :src="aboutList[0].pic" alt="">
          <div id="avoutId"  style="cursor: pointer;font-size: 1.2vw;width: 100%;margin-top: 1vw;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;"><b>{{aboutList[0].title}}</b></div>
        </div>
        <div class="about-list">
          <div v-for="(item,index) in aboutList" :key="index" class="about-item" @click="gonewsdetail(item.id,item)" v-if="index != 0" :class="index != 3 ? 'aboutact' : ''" >
            <!-- <img src="./images/wenjianjia.png" alt=""> -->
            <div id="avoutId" class="aboutTitle"><b>{{item.title}}</b></div>
            <div style="font-size:0.8vw;margin-top: 1vw;font-family: Microsoft YaHei;font-weight: 400;color: #333333;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;" >{{ item.subTitle }}</div>
          </div>
        </div>
      </div>
      
    <!-- <indexFooter></indexFooter> -->
   </div>
   
   
    <el-dialog :title="title" :visible.sync="dialogVisible" :before-close="handleDialogClose" width="50%">
      <div style="height: 27vw;">
        <video
        style="height:26vw"
        v-if="vuedoshow == 1"
            :src="src1"
            controls
            width="100%"
            ref="vueRef"
        ></video>
        <video
        style="height:26vw"
        v-else
            :src="src2"
            controls
            width="100%"
           
            ref="vueRef"
        ></video>
</div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleclick()">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleclick()">确 定</el-button>
      </span> -->
    </el-dialog>

  </div>
</template>

<script>
  import util from '@/util/util.js'
  import Axios from 'axios'
  import navHeader from '@/components/indexHeader'
  import indexFooter from '@/components/indexFooter'
  import vueQr from 'vue-qr'
  export default {
    components:{
    navHeader,
    indexFooter,
    vueQr
  }, 
    data() {
      return {
        providerCount:0,
        instiCount:0,
        fwcplist:[
          {name:'救援清单'},
          {name:'全球救援'},
          {name:'健康监测'},
          {name:'全球医疗'},
        ],
        title:'',
        vuedoshow:1,
        src1: 'https://f.dajiuxing.com.cn/mp4/intro.mp4',
        src2: 'https://f.dajiuxing.com.cn/p3/a/2026/0901/0917/nullcb72e708_1f3b6a450782248_0.mp4',
        // src1:'',
        // src2:'',
        act:0,
        logoSrc:require('./img/logo.png'),
        prodectListL:0,
        prodectListR:6,
        prodectListLength:1,
        prodectPagenumber:1,
        yiqianYuList:[],
        fullpage: {
    current: 1, // 当前的页面编号
    isScrolling: false, // 是否在滚动,是为了防止滚动多页，需要通过一个变量来控制是否滚动
    deltaY: 0 // 返回鼠标滚轮的垂直滚动量，保存的鼠标滚动事件的deleteY,用来判断是往下还是往上滚
    },
        dialogVisible: false,
        serviceNum: 1,
        typeNum: 1,
        productNum: 0,
        productIndex: null,
        carouselArr: '',
        productState: false,
        caseShareState: false,
        caseShareIndex:null,
        caseList: [{
          pic: ''
        }],
        caseDataList: [
          {
            url: require('./images/case5.png'),
            icon:require('./images/icon5.png'),
            name:'旅游',
            type:'针对商旅出行、旅游观光等场景提供成品定制及系统解决方案'
          },
          {
            url: require('./images/case6.png'),
            icon:require('./images/icon6.png'),
            name:'户外',
            type:'针对商旅出行、旅游观光等场景提供成品定制及系统解决方案'
          },
          {
            url: require('./images/case7.png'),
            icon:require('./images/icon7.png'),
            name:'潜水',
            type:'针对商旅出行、旅游观光等场景提供成品定制及系统解决方案'
          },
          {
            url: require('./images/case8.png'),
            icon:require('./images/icon8.png'),
            name:'体育',
            type:'针对商旅出行、旅游观光等场景提供成品定制及系统解决方案'
          },{
            url: require('./images/case1.png'),
            icon:require('./images/icon1.png'),
            name:'马术',
            type:'针对商旅出行、旅游观光等场景提供成品定制及系统解决方案'
          },
          {
            url: require('./images/case2.png'),
            icon:require('./images/icon2.png'),
            name:'家政',
            type:'针对商旅出行、旅游观光等场景提供成品定制及系统解决方案'
          },
          {
            url: require('./images/case3.png'),
            icon:require('./images/icon3.png'),
            name:'教育',
            type:'针对商旅出行、旅游观光等场景提供成品定制及系统解决方案'
          },
          {
            url: require('./images/case4.png'),
            icon:require('./images/icon4.png'),
            name:'货运',
            type:'针对商旅出行、旅游观光等场景提供成品定制及系统解决方案'
          },

        ],
        advantageList:[
          {
            num:'01',
            name:'在线问诊'
          },
          {
            num:'02',
            name:'视频问诊'
          },
          {
            num:'03',
            name:'星使服务'
          },
          {
            num:'04',
            name:'商务法律'
          },
          {
            num:'05',
            name:'健康管理'
          },
          {
            num:'06',
            name:'拓展服务'
          },
        ],
        aboutList: [],
        newsList: [{
          pic: ''
        }],
        // api:'http://api.dajiuxing.com.cn', 
        api:util.config.api,
        productList: [{
            title: '大救星境外留学意外伤害保险',
            price: '691',
            url: require('./images/product-1.png')
          },
          {
            title: '大救星境外留学意外伤害保险',
            price: '691',
            url: require('./images/product-2.png')
          },
          {
            title: '大救星境外留学意外伤害保险',
            price: '691',
            url: require('./images/product-3.png')
          },
          {
            title: '大救星境外留学意外伤害保险',
            price: '691',
            url: require('./images/product-4.png')
          },
          {
            title: '大救星境外留学意外伤害保险',
            price: '691',
            url: require('./images/product-5.png')
          },
          {
            title: '大救星境外留学意外伤害保险',
            price: '691',
            url: require('./images/product-6.png')
          }
        ]
      };
    },
    created() {
      this.getData()
      this.fwsss()
    },
    methods: {
      
      handleDialogClose() {
        this.dialogVisible = false;
        this.$refs.vueRef.pause();//暂停
      },
      handleEnter(ind) {
        this.act = ind
      },
      handleLeave(ind) {
        this.act = ind
      },
      leftClick() {
        this.prodectPagenumber  = this.prodectPagenumber - 1
        this.prodectListL = this.prodectListL-6
        this.prodectListR = this.prodectListR-6
       
        const sliceA=this.yiqianYuList.slice(this.prodectListL,this.prodectListR)
           this.productList = sliceA
      },
      rightClick() {
        this.prodectPagenumber  = this.prodectPagenumber + 1
        console.log(this.prodectListL+6,this.prodectListR+6)
        this.prodectListL = this.prodectListL+6
        this.prodectListR = this.prodectListR+6
     
        const sliceA=this.yiqianYuList.slice(this.prodectListL,this.prodectListR)
           this.productList = sliceA
        console.log(this.prodectListLength)
        console.log(this.yiqianYuList)
      },
      next() { // 往下切换
    let len = 10; // 页面的个数
    if (this.fullpage.current + 1 <= len) { // 如果当前页面编号+1 小于总个数，则可以执行向下滑动
    this.fullpage.current += 1; // 页面+1
    this.move(this.fullpage.current); // 执行切换
    }
   },
   pre() {// 往上切换
    if (this.fullpage.current - 1 > 0) { // 如果当前页面编号-1 大于0，则可以执行向下滑动
    this.fullpage.current -= 1;// 页面+1
    this.move(this.fullpage.current);// 执行切换
    }
   },
   move(index) {
    this.fullpage.isScrolling = true; // 为了防止滚动多页，需要通过一个变量来控制是否滚动
    this.directToMove(index); //执行滚动
    setTimeout(() => {  //这里的动画是1s执行完，使用setTimeout延迟1s后解锁
    this.fullpage.isScrolling = false;
    }, 1010);
   },
   directToMove(index,type) {
    let height =  height = this.$refs["fullPage"].clientHeight; //获取屏幕高度
    console.log(height)
    let scrollPage = this.$refs["fullPageContainer"]; // 获取执行tarnsform的元素
    let scrollHeight; // 计算滚动的告诉，是往上滚还往下滚
    scrollHeight= -(index - 1) * height + "px";
    scrollPage.style.transform = `translateY(${scrollHeight})`;
    this.fullpage.current = index;
   },
  //  mouseWheelHandle(event) { // 监听鼠标监听
  //   // 添加冒泡阻止
  //   let evt = event || window.event;
  //   if (evt.stopPropagation) {
  //   evt.stopPropagation();
  //   } else {
  //   evt.returnValue = false;
  //   }
  //   if (this.fullpage.isScrolling) { // 判断是否可以滚动
  //   return false;
  //   }
  //   let e = event.originalEvent || event;
  //   this.fullpage.deltaY = e.deltaY || e.detail; // Firefox使用detail
  //   if (this.fullpage.deltaY > 0) {
  //   this.next();
  //   } else if (this.fullpage.deltaY < 0) {
  //   this.pre();
  //   }
  //  },
      // 点击视频 ==》弹窗
      clickVideo(item) {
        if(item == 1) {
          this.title = '两分钟了解大救星'
        }else {
          this.title = '大救星“一键呼救”'
        }
        this.vuedoshow = item
        this.dialogVisible = true
      },
      // 点击服务 ==》切换服务
      clickService(num) {
        let number  = this.serviceNum - num
        let time = 1500
        if(Math.abs(number)>4){
          time = 2500
        }else if(Math.abs(number)>2){
          time = 2000
        }
        this.serviceNum = num
        this.$refs.serviceBox.forEach((v) => {
          const moveDis = (num - 1) * 65.416;
          v.style = `transform:translateX(-${moveDis}vw);transition-duration: ${time}ms`;
        })
      },
      // 选择服务
      clickType(num) {
        let number  = this.typeNum - num
        let time = 1500
        if(Math.abs(number)>4){
          time = 4000
        }else if(Math.abs(number)>2){
          time = 2500
        }
        this.typeNum = num
        this.$refs.advantageBox.forEach((v) => {
          const moveDis = (num - 1) * 65.416;
          v.style = `transform:translateX(-${moveDis}vw);transition-duration: ${time}ms`;
        })
      },
      // 选择产品
      clickProduct(index) {
        this.productNum = index
      },
      // 上一页
      previous() {
        this.typeNum = this.typeNum - 1
        this.$refs.advantageBox.forEach((v) => {
          const moveDis = (this.typeNum - 1) * 65.416;
          v.style = `transform:translateX(-${moveDis}vw);transition-duration: 1500ms`;
        })
      },
      // 下一页
      next1() {
        this.typeNum = this.typeNum + 1
        this.$refs.advantageBox.forEach((v) => {
          const moveDis = (this.typeNum - 1) * 65.416;
          v.style = `transform:translateX(-${moveDis}vw);transition-duration: 1500ms`;
        })
      },
      // 服务产品鼠标移入事件
      mouseOver(index) {
        if (!this.productState) {
          this.productState = true
          this.productIndex = index
          this.$refs.productDom[index].style = 'width:var(--product-expanded-width);transition:1s'
          if (index == 2 || index == 5) {
            this.$refs.productDom[index - 1].style = 'width:0;opacity:0;transition:1s'
          } else {
            this.$refs.productDom[index + 1].style = 'width:0;opacity:0;transition:1s'
          }
        }
      },
      // 服务产品鼠标移出事件
      mouseLeave(index) {
        this.productState = false
        this.productIndex = null
        this.$refs.productDom.forEach((item,index) => {
          item.style = 'width:var(--product-card-width);opacity:0.9;transition:1s'
        })
      },

      // 案例鼠标移入事件
      caseShareOver(index){
        if(!this.caseShareState){
          this.caseShareState = true
          this.caseShareIndex = index
          this.$refs.caseShareDmo.forEach((item,num)=>{
            if(index<=3 && num<=3){
              // item.style = 'width:12.760416vw;transition:1s'
              item.style.width = "var(--case-narrow-width)";
              item.style.transition = "1s";
            }else if(index>3 && num>3){
              item.style.width = "var(--case-narrow-width)";
              item.style.transition = "1s";
            }
          })
          console.log(this.$refs.caseShareDmo[index].style)
          this.$refs.caseShareDmo[index].style.width = 'var(--case-expanded-width)';
          this.$refs.caseShareDmo[index].style.transition = '1s' 
        }

      },
      // 案例鼠标移出事件
      caseShareLeave(index){
        this.caseShareState = false
        this.caseShareIndex = null
        this.$refs.caseShareDmo.forEach((item,num)=>{
          item.style.width = 'var(--case-card-width)';
          item.style.transition = '1s' 
        })
      },


      getCarouseImg() {
        Axios({
          methods: 'post',
          baseURL: this.api,
          url: '/1.0/portal/portalBanner'
        }).then(res => {
          this.carouselArr = res.data.obj;
          // console.log(this.carouselArr,'图片集合')
        }).catch(error => {
          console.log(error)
        })
      },
      getNewsList() {
        Axios({
          params: {
            category: '1', //1 资讯
            start: '0',
            type:'12',
            count: '4'
          },
          methods: 'post',
          baseURL:this.api,
          url: '/1.0/news/news-list'
        }).then(res => {
          // console.log(res,'首页资讯');
          this.newsList = res.data.obj;
          this.aboutList = res.data.obj
        }).catch(error => {
          console.log(error)
        })
      },
      getCaseList() {
        Axios({
          params: {
            category: '2', //2 服务案例
            start: '0',
            type:'11',
            count: '8'
          },
          methods: 'post',
          baseURL: this.api,
          url: '/1.0/news/news-list'
        }).then(res => {
          // console.log(res,'首页案例');
          this.caseList = res.data.obj;
          this.caseDataList = res.data.obj
        }).catch(error => {
          console.log(error)
        })
      },
      getData() {
        Axios.all([this.getCarouseImg(), this.getNewsList(), this.getCaseList()])
          .then(Axios.spread(function(acct, perms) {
            //两个都执行
            // console.log(acct)
            // 
            
          }))
          Axios.get(this.api + '/rescue_sale/product/listChannelProduct',{
           params:{
             channelId:2011
           }
         })
         .then(res => {
          console.log(res)
          for(var i = 0; i< res.data.obj.length; i++) {
            if(res.data.obj[i].id == 491) {
              res.data.obj.splice(i,1)
            }
          }
          if(res.data.obj[0] != null && res.data.obj[0] != undefined) {
            res.data.obj[0].url = require('./images/product-1.png')
          }
          if(res.data.obj[1] != null && res.data.obj[1] != undefined) {
            res.data.obj[1].url = require('./images/product-2.png')
          }
          if(res.data.obj[2] != null && res.data.obj[2] != undefined) {
            res.data.obj[2].url = require('./images/product-3.png')
          }
          if(res.data.obj[3] != null && res.data.obj[3] != undefined) {
            res.data.obj[3].url = require('./images/product-4.png')
          }
          if(res.data.obj[4] != null && res.data.obj[4] != undefined) {
            res.data.obj[4].url = require('./images/product-5.png')
          }
          if(res.data.obj[5] != null && res.data.obj[5] != undefined) {
            res.data.obj[5].url = require('./images/product-6.png')
          }
          if(res.data.obj[6] != null && res.data.obj[6] != undefined) {
            res.data.obj[6].url = require('./images/product-1.png')
          }
          if(res.data.obj[7] != null && res.data.obj[7] != undefined) {
            res.data.obj[7].url = require('./images/product-2.png')
          }
          if(res.data.obj[8] != null && res.data.obj[8] != undefined) {
            res.data.obj[8].url = require('./images/product-4.png')
          }
          if(res.data.obj[9] != null && res.data.obj[9] != undefined) {
            res.data.obj[9].url = require('./images/product-5.png')
          }
          if(res.data.obj[10] != null && res.data.obj[10] != undefined) {
            res.data.obj[10].url = require('./images/product-6.png')
          }
           this.prodectListLength=Math.ceil(res.data.obj.length/6)
           const sliceA=res.data.obj.slice(0,6)
           this.productList = sliceA
           console.log(sliceA)
           console.log(res.data.obj)
           console.log(res,'rescue_sale/product/listChannelProduct');
           this.yiqianYuList=res.data.obj
            
         })
         .catch(err => {
           console.log(err)
         })
      },
      fwsss() {
        Axios({
          params: {
          },
          methods: 'post',
          baseURL: this.api,
          url: '/rescue/screen/total'
        }).then(res => {
          this.instiCount = res.data.obj.instiCount
          this.providerCount = res.data.obj.providerCount
          // console.log(res,'服务商');
          // console.log(res.data.providerCount,'星使');
        }).catch(error => {
          console.log(error)
        })
   
      },
      gonewslist() {
        this.$router.push({
          path: 'aboutus',
          query: {
            activeName: 'news'
          }
        });
      },
      gocaselist() {
        this.$router.push({
          path: 'aboutus',
          query: {
            activeName: 'case'
          }
        });
      },
      gonewsdetail(id,item) {
        console.log(item)
        if(item.attribute == 4) {
        window.open(item.url)
      }else {
        this.$router.push({
          path: 'aboutus',
          query: {
            activeName: 'news',
            id: id
          }
        });
      }
      
      },
      list(pid, id) {
        this.$root.bus.$emit('only', 2)
        this.$router.push({
          name: 'rescuelist',
          params: {
            pid: pid,
            id: id
          }
        })
      },
      gocasedetail(id,item) {
        if(item.attribute == 4) {
        window.open(item.url)
      }else {
        this.$router.push({
          path: 'aboutus',
          query: {
            activeName: 'case',
            id: id
          }
        });
      }
      }
    }
  }
</script>
<style lang="scss" scoped>
/* 根节点 zoom 下，100% 与 100vw 不等宽；沿用平台系统的父容器宽度减两侧留白。 */
#app .home-content {
  width: calc(100% - 30vw);
  margin-left: auto;
  margin-right: auto;
}

/* 保持服务领域上二下三的分组，避免宽屏下浮动布局重新排成一行。 */
.service-list {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 170px 3vw;
}

.service-list > div {
  display: flex;
  gap: 2vw;
  grid-column: span 2;
}

.service-list > div:nth-child(-n + 2) {
  grid-column: span 3;
}

.service-description {
  flex: 1;
  min-width: 0;
}

/* 五张特色卡片均匀铺满内容区，避免原有左内边距导致两侧不齐。 */
.characteristic-list {
  display: flex;
  justify-content: space-between;
}

.characteristic-list > div {
  float: none;
  margin-left: 0;
}

.titlebg {
  width: 38%;
  height: 25px;
  padding-left: 2%;
  font-size: 1.8vh;
  background: url(img/titlebg.png) no-repeat center center;
}
.aboutact {
  border-bottom: 1px solid #CACACA;
}

.act {
  width:10vw !important;
}
.zs {
  width:25%;
  height: 30vh;
  float: left;
  text-align: center;
}
.businessdiv {

  width: 60%;
  height: 3vw;
  text-align: center;
  line-height: 2.8vw;
  border: 2px solid transparent;
  border-radius: 10px;
  background-clip: padding-box, border-box;
  background-origin: padding-box, border-box;
  background-image: linear-gradient(to right, #F6F7F7, #F6F7F7),
  linear-gradient(to right, #00C0FA, #015EEA);
  font-size: 0.9vw;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #4176FB;
  position: absolute;
    bottom: 0px;
    left:20%
}
.section9 {
  background-color: #F6F7F7;
}
.section10 {
  background-color: #F6F7F7;
}
.resourcesbg {
  background: url(img/zxy.png) no-repeat top;
  background-size: 100%;
  height: 68vh;
  position: relative;
}
.characteristic1 {
  background: url(img/characteristic1.png) no-repeat top;
  background-size: 100%;
  width: 12vw;
  height: 24vw;
  float: left;
  margin-left:0px;
  overflow: hidden; 
  transition: all linear 0.5s;
}
.characteristic1{  
    cursor: pointer;  
    transition: all 0.5s; /* 所有的属性变化在0.5s的时间段内完成 */
}  
.characteristic1:hover{  
    transform: scale(1.1); /* 鼠标放到图片上的时候图片按比例放大1.5倍   */
}  
.characteristic2 {
  background: url(img/characteristic2.png) no-repeat top;
  background-size: 100%;
  width: 12vw;
  height: 24vw;
  float: left;
  overflow: hidden; 
  margin-left:10px
}
.characteristic2{  
    cursor: pointer;  
    transition: all 0.5s; /* 所有的属性变化在0.5s的时间段内完成 */
}  
.characteristic2:hover{  
    transform: scale(1.1); /* 鼠标放到图片上的时候图片按比例放大1.5倍   */
}  
.characteristic3 {
  background: url(img/characteristic3.png) no-repeat top;
  background-size: 100%;
  width: 12vw;
  height: 24vw;
  float: left;
  overflow: hidden; 
  margin-left:10px
}
.characteristic3{  
    cursor: pointer;  
    transition: all 0.5s; /* 所有的属性变化在0.5s的时间段内完成 */
}  
.characteristic3:hover{  
    transform: scale(1.1); /* 鼠标放到图片上的时候图片按比例放大1.5倍   */
}  
.characteristic4 {
  background: url(img/characteristic4.png) no-repeat top;
  background-size: 100%;
  width: 12vw;
  height: 24vw;
  float: left;
  overflow: hidden; 
  margin-left:10px
}
.characteristic4{  
    cursor: pointer;  
    transition: all 0.5s; /* 所有的属性变化在0.5s的时间段内完成 */
}  
.characteristic4:hover{  
    transform: scale(1.1); /* 鼠标放到图片上的时候图片按比例放大1.5倍   */
}  
.bt1 {
  background: url(img/qiu1.png) no-repeat top;
  background-size: 100%;
  width: 113px;
  height: 5vw;
  font-size: 28px;
    color: #Ffff;
    text-align: center;
    line-height: 3.5vw;

}
.bt2 {
  background: url(img/qiu2.png) no-repeat top;
  background-size: 100%;
  width: 113px;
  height: 5vw;
  font-size: 28px;
    color: #Ffff;
    text-align: center;
    line-height: 3.5vw;

}
.characteristic5 {
  background: url(img/characteristic5.png) no-repeat top;
  background-size: 100%;
  width: 12vw;
  height: 24vw;
  float: left;
  overflow: hidden; 
  margin-left:10px
}
.characteristic5{  
    cursor: pointer;  
    transition: all 0.5s; /* 所有的属性变化在0.5s的时间段内完成 */
}  
.characteristic5:hover{  
    transform: scale(1.1); /* 鼠标放到图片上的时候图片按比例放大1.5倍   */
}  
.xiahua {
  position: absolute;
  bottom: 30px;
}
.fullPage{
     height: 100vh; 
    //  overflow: hidden; 
    //  background-color: rgb(189, 211, 186);
    }
    .fullPageContainer{
     width: 100%;
     height: 100vh;
     transition: all linear 0.5s;
    }
    .section {
     width: 100%;
     height: 100vh;
     padding-top: 85px;
     background-position: center center;
     background-repeat: no-repeat;
    }
    .section1 {
    //  background-color: rgb(189, 211, 186);
    }
    .section1 .secction1-content {
     color: #fff;
     text-align: center;
     position: absolute;
     top: 40%;
     right: 0;
     left: 0;
    }
    .secction1-content h1 {
     font-size: 40px;
     padding-bottom: 30px;
    }
    .secction1-content p {
     font-size: 20px;
    }
    .section2 {
    //  background-color: rgb(44, 48, 43);
    }
    .section3 {
    //  background-color: rgb(116, 104, 109);
    }
    .section4 {
    //  background-color: rgb(201, 202, 157);
    }
  // 混合宏
  @mixin cssdefault {
    box-shadow: 0 0 4px 0 rgba(255, 255, 255, 0);
    transition: all .5s ease-in;
  }

  @mixin csshover {
    box-shadow: 0 0 0.78125vw rgba(0, 0, 0, .1);
    -webkit-transform: translate3d(0, -5px, 0);
    transform: translate3d(0, -5px, 0);
  }

  @mixin ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  @mixin spanBg {
    width: 1.35416vw;
    height: 1.35416vw;
    opacity: 0.3;
    border-radius: .677083vw .10416px .677083vw .677083vw;

  }



  #app {
    background: #fff;
    -webkit-text-size-adjust: none;
  }

  #app * {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    /* Firefox */
    -webkit-box-sizing: border-box;
    /* Safari */
  }

  .banner {
    margin-top: 1px;
    background: url(images/banner.png) no-repeat center center;
    background-size: 100% 100%;
    width: 100%;
    height: 37vw;
    /* 首屏内容沿用平台系统的左右留白，背景保持整行铺满。 */
    padding: 0 15vw;
    position: relative;
    display: flex;
    overflow: hidden;
    animation: bannerShow 1.5s;
    .banner_left {
      padding-top: 5.1vw;

      .banner_title {
        font-size: 2.9166667vw;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #000;
        letter-spacing:0.4883vw;
        // margin-bottom: 1.333vw;
      }

      .banner_left_type>span {
        margin-top: 1vw;
        display: inline-block;
        width: 6.25vw;
        height: 2.604166vw;
        border: .104166vw solid #83a4d2;
        border-radius: 1.30208vw;
        font-size: 1.30208vw;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #83a4d2;
        text-align: center;
        line-height: 2.604166vw;
        margin-right: 1.25vw;
      }

      .experience {
        // margin-top: 2.08vw;
        margin-bottom: 3.02vw;
        width: 10.46875vw;
        // height: 3.33333vw;
        // background: #4176FB;
        border-radius: 1.5625vw 0.20833vw 1.5625vw 1.5625vw;
        line-height: 3.33333vw;
        text-align: center;
        font-size: 1.25vw;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #FFFFFF;

        img {
          width: 2.39583vw;
          height: .8333vw;
        }
      }

      .video_box {
        display: flex;

        .video {
          width: 14.2125vw;
          height: 11.2083vw;
          margin-right: .62916vw;
          background-color: #FFFFFF;
          position: relative;
          z-index: 100;

          img {
            width: 100%;
            height: 8.65625vw;
          }

          span {
            position: absolute;
            width: 3.28125vw;
            height: 1.40625vw;
            background: #F5F6F8;
            border-radius: 0vw 0vw 1.40625vw 0vw;
            text-align: center;
            font-size: .72916vw;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #30BB81;
          }

          p {
            width: 100%;
            height: 2.3vw;
            background: #FFFFFF;
            border: .15625vw solid #FFFFFF;
            box-shadow: 0px .15625vw .260416vw 0px rgba(66, 126, 150, 0.1500);
            opacity: 0.69;
            font-size: .989583vw;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #222;
            text-align: center;
            line-height: 2vw;
          }
        }
        .video:hover{
          cursor:pointer;
        }
      }
    }

    .banner_right {

      @keyframes bannerShow {
        from {
          opacity: 0;
        }

        to {
          opacity: 1;
        }
      }

      @keyframes bannerMoveLeft {
        from {
          transform: translateX(-10vw);
        }

        to {
          transform: translateX(0vw)
        }
      }
      @keyframes bannerMoveRight {
        from {
          transform: translateX(10vw);
        }

        to {
          transform: translateX(0vw)
        }
      }


      .banner_right_item {
        animation-name: bannerShow;
        animation-duration: 3s;
        animation-fill-mode: forwards;
        position: absolute;
        z-index: 99;

        .text {
          padding: 0 .72916vw;
          height: 1.97916vw;
          line-height: 1.97916vw;
          background: #F5F6F8;
          border-radius: .2083vw;
          font-size: .9375vw;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #6C91D5;

          span {
            font-size: 1.14583vw;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #6C91D5;
          }
        }
        .textLeft{
          animation: bannerMoveLeft 3s;
          animation-fill-mode: forwards;
        }
        .textRight {
          animation: bannerMoveRight 3s;
          animation-fill-mode: forwards;
        }
      }



    }

    .banner_right>div:nth-child(1) {
      right: 32.8125vw;
      top: 4.214583vw;

      img {
        margin-left: 50%;
        margin-top: .677083vw;
        width: 7.6041vw;
        height: 5.3125vw;
      }
    }

    .banner_right>div:nth-child(2) {
      right: 36.383vw;
      bottom: 4.7375vw;

      img {
        margin-left: 45%;
        margin-bottom: .677083vw;
        width: 6.14583vw;
        height: 4.166vw;
      }
    }

    .banner_right>div:nth-child(3) {
      right: 15vw;
      bottom: 18.2416vw;

      img {
        margin-left: 30%;
        margin-bottom: .677083vw;
        width: 3.4695vw;
        height: 3.5295vw;
      }

    }

    .banner_right>div:nth-child(4) {
      right: 15vw;
      bottom: 11.91875vw;

      img {
        margin-left: 30%;
        margin-bottom: .677083vw;
        width: 3.4695vw;
        height: 3.6979vw;
      }
    }
  }


  .service {
    min-height: 620px;
    // overflow: hidden;
    margin: 0 auto;
    margin-top:55px;

    .title {
      position: relative;
      text-align: center;

      span {
        position: relative;
        left: -.62vw;
        font-size: 1.5vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 1.35416vw;
      }
    }

    .menu-box {
      display: flex;
      justify-content: space-between;
      .menu {
        position: relative;
        width: 15.72916vw;
        height: 7.5vw;
        img {
          width: 15.72916vw;
          height: 7.5vw;
        }

        span {
          position: absolute;
          font-size: 1.0416vw;
          font-family: Microsoft YaHei;
          font-weight: 600;
          color: #FFFFFF;
          z-index: 99;
          width: 100%;
          top: 4.322916vw;
          left: 1.45833vw;
        }
      }
      .menu:hover{
        cursor:pointer;
      }
      // .menu_box {
      //   border-radius: .520833vw;
      //   border-bottom: .572916vw solid rgba(0,0,0,0.21);
      // }
    }

    .progress-box {
      width: 100%;
      height: 1.6666vw;
      background-color: #DEF2F1;
      opacity: 0.73;
      border-radius: .8333vw;
      margin: 1.5625vw 0;
      position: relative;

      .progress {
        position: absolute;
        z-index: 99;
        width: 1.875vw;
        height: 1.875vw;
        border-radius: .677083vw .10416px .677083vw .677083vw;
        text-align: center;

        span {
          margin-top: .260416vw;
          display: inline-block;
          width: 1.35416vw;
          height: 1.35416vw;
          opacity: 0.3;
          border-radius: .677083vw .10416px .677083vw .677083vw;
        }
      }

      .progress1 {
        border: 0.00183vw solid #F57390;
      }

      .progress2 {
        border: 0.00183vw solid #2DCAFD;
      }

      .progress3 {
        border: 0.00183vw solid #8DC72D;
      }

      .progress4 {
        border: 0.00183vw solid #FFC447;
      }
    }

    .progress-box>div:nth-child(1) {

      span {
        background: #F57390;
      }
    }

    .progress-box>div:nth-child(2) {
      left: 16.3802vw;

      span {
        background: #2DCAFD;
      }
    }

    .progress-box>div:nth-child(3) {
      left: 32.7604vw;

      span {
        background: #8DC72D;
      }
    }

    .progress-box>div:nth-child(4) {
      left: 49.140625vw;

      span {
        background: #FFC447;
      }
    }

    .content_div {
      width: 262.6667vw;

    }

    .content {
      display: inline-block;
      width: 65.416vw;
      height: 24.7916vw;
      background: url(images/2-bg-3.png) no-repeat center center;
      background-size: 100% 100%;
      position: relative;

      .content_box {
        position: absolute;
        width: 42.71vw;
        left: 22.96875vw;
        top: 5.4166vw;

        .content-item {
          width: 13.385416vw;
          display: inline-block;
          height: 4.375vw;
          margin-right: .72916vw;
          margin-bottom: .72916vw;
          background: url(images/non-icon-bg.png) no-repeat center center;
          background-size: 100% 100%;

          span {
            font-size: .833vw;
            line-height: 4.375vw;
            margin-left: 1.25vw;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
          }
        }
      }

    }
  }


  .advantage {

    width: 100%;
    // padding-top: 0.001vw;
    height: 700px;
    // background: url(images/3-bg.png) no-repeat center center;
    background-size: 100% 100%;
    // margin-top: 70px;




    .advantage-content {
      margin: 0 auto;
      // margin-top: 2.08125vw;

      .title {
        position: relative;
        text-align: center;

        span {
          position: relative;
          left: -.62vw;
          font-size: 1.5vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 1.35416vw;
        }
      }

      .bg {
        width: 100%;
        height: 12.864583vw;
        background: url(images/yuanhuan.png) no-repeat center center;
        background-size: 100% 100%;
        position: relative;
        margin-top: 2.035416vw;

        div {
          width: 7.5vw;
          height: 7.5vw;
          border-radius: 50%;
          position: absolute;
          font-size: .9375vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          text-align: center;
          line-height: 1.4vw;
          top: 1.8vw;

          p:nth-child(1) {
            margin-top: 2.604vw;
          }

          img {
            margin-top: 3vw;
          }
          img + p {
            font-weight: 600;
          }
        }
        div:hover{
          cursor:pointer;
        }
        .nav-p {
          font-weight: 600;
        }
      }

      .bg>div:nth-child(1) {
        left: 1.66875vw;

      }

      .bg>div:nth-child(2) {
        left: 12.683vw;
      }

      .bg>div:nth-child(3) {
        left: 23.494583vw;
      }

      .bg>div:nth-child(4) {
        left: 34.514583vw;
      }

      .bg>div:nth-child(5) {
        left: 45.347916vw;
      }

      .bg>div:nth-child(6) {
        left: 56.49375vw;
      }

      .advantage_div {
        overflow: hidden;
        width: 65.416vw;
      }

      .tab-box {
        width: 392.5vw;
      }

      .tab-item {
        width: 65.416vw;
        display: inline-block;
        height: 36.77083vw;
        background: url(images/3-bg-3.png) no-repeat center center;
        background-size: 100% 100%;
        position: relative;
        font-size: .83333vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #0F5B6E;
        line-height: 1.5104vw;

        .text-title {
          width: 13.64583vw;
          position: absolute;
          top: 7.4479vw;
          left: 27.39583vw;
        }
        .text-img {
          img{
            width: 3.59375vw;
            height: 3.59375vw;
          }
        }
      }

      .tab-item>div:nth-child(1) {
        position: absolute;
        left: 5vw;
        top: 5.22083vw;
      }

      .tab-item>div:nth-child(2) {
        position: absolute;
        left: 5vw;
        top: 10.84583vw;
      }

      .tab-item>div:nth-child(3) {
        position: absolute;
        left: 5vw;
        top: 16.5229vw;
      }

      .tab-item>div:nth-child(4) {
        position: absolute;
        left: 5vw;
        top: 22.4083vw;
      }

      .tab-item>div:nth-child(5) {
        position: absolute;
        left: 5vw;
        top: 28.1375vw;
      }

      .tab-item>div:nth-child(7) {
        position: absolute;
        right: 1vw;
        top: 7.34375vw;
        text-align: right;

        p {
          margin-right: 1.71875vw;
        }
      }

      .tab-item>div:nth-child(8) {
        position: absolute;
        right: 1vw;
        top: 18.802vw;
        text-align: right;

        p {
          margin-right: 1.71875vw;
        }
      }

      .qiehuan {
        width: 100%;
        text-align: center;
      }
      .qiehuan>img:hover{
        cursor:pointer;
      }
      .qiehuan>img:nth-child(1) {
        margin-right: .72916vw;
      }
    }
  }

  .product {
    /* 三列卡片及悬停展开共享内容区宽度，避免交互后重新出现大间隙。 */
    --product-card-width: calc((100% - 2vw) / 3);
    --product-expanded-width: calc((200% - 1vw) / 3);
    margin: 0 auto;
    margin-top:70px;
    margin-bottom: -49px;
    .title {
      position: relative;
      text-align: center;

      span {
        position: relative;
        left: -.62vw;
        font-size: 1.5vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 1.35416vw;
      }
    }

    .navTab {
      width: 100%;
      display: flex;
      margin-top: 1.927083vw;
      margin-left: -21px;
      .navTab-item {
        width: 5.52083vw;
        height: 2.1875vw;
        background: #F1F2F4;
        border-radius: 1.09375vw;
        font-size: .833vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        text-align: center;
        line-height: 2.1875vw;
        margin-left:21px;
      }
      .navTab-item:hover{
        cursor:pointer;
      }
      .navTabOnly {
        background: #90C231;
        color: #FFFFFF;
      }
    }
    .product_name {
          width: 15.59583vw;
          font-size: 1.14583vw;
          line-height: 1.97916vw;
          margin-left: 2.03125vw;
          margin-top: 3.02083vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #FFFFFF;
        }
    .product_box {
      width: 100%;
      display: flex;
      float: left;
      margin-top: 60px;
      flex-wrap: wrap;
      justify-content: space-between;
      overflow: hidden;
      height: 35.520833vw;
      .product-item {
        width: var(--product-card-width);
        height: 16.77083vw;
        border-radius: .72916vw;
        margin-bottom: 1.04166vw;
        position: relative;
        opacity: 0.9;

        .bg-img {
          position: absolute;
          width: 100%;
          height: 16.77083vw;
          left: 0;
          top: 0;
          z-index: -1;
        }
        .product_price {
          position: absolute;
          font-size: .8333vw;
          left: 2.03125vw;
          bottom: 6.510416vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #FFFFFF;

          span {
            color: #FFFFFF;
            font-size: 1.5625vw;
          }
        }

        .product_info {
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #FFFFFF;
          position: absolute;
          left: 2.03125vw;
          bottom: 1.875vw;
          width: 9.447916vw;
          height: 2.5vw;
          border: 1px solid #FFFFFF;
          border-radius: 1.25vw;
          text-align: center;
          line-height: 2.5vw;
        }

        .product_hover {
          width: 100%;
          display: flex;
          animation: typeMove 3s;
          animation-fill-mode:forwards;
          .product_left {
            flex: 1;

            .product_title {
              font-size: 1.14583vw;
              line-height: 1.97916vw;
              margin-left: 2.03125vw;
              margin-top: 3.02083vw;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #FFFFFF;

            }

            .product_type {
              width: 100%;
              display: flex;
              flex-wrap: wrap;
              padding-left: 2.03125vw;

              div {
                padding: .4166vw 1.197916vw;
                color: #fff;
                font-size: .72916vw;
                background-color: rgba(255, 255, 255, 0.23);
                border-radius: .72916vw;
                margin-right: .68916vw;
                margin-bottom: .61916vw;
              }
            }

            .introduce {
              padding-left: 2.03125vw;

              div {
                font-size: .83333vw;
                color: #fff;
                margin-bottom: .833vw;
                span {
                  font-size: .83333vw;
                  color: #fff;
                }
              }

              .yuan {
                display: inline-block;
                width: .52083vw;
                height: .52083vw;
                border-radius: 50%;
                background-color: #fff;
                margin-right: .72916vw;
              }

              .name {
                font-weight: 600;
              }
            }
          }

          .product_right {
            width: 9.53125vw;
            height: 13.072916vw;
            margin-top: 2.39583vw;
            margin-right: 2.70833vw;
            // padding-top: 20px;
            // padding-left:20px;
            text-align: center;
            border: 1px solid #FFFFFF;
            border-radius: .2083vw;

            .right_price {
              font-size: .8333vw;
              // margin-left: 2.447916vw;
              // margin-top: 4.0625vw;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #FFFFFF;

              span {
                color: #FFFFFF;
                font-size: 1.5625vw;
              }
            }

            .right_info {
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333;
              margin: 0 auto;
              margin-top:0.5vw;
              width: 7.447916vw;
              height: 2vw;
              font-size: 1vw;
              background-color: #fff;
              border-radius: 1.25vw;
              text-align: center;
              line-height: 2vw;
            }
          }
        }

      }
      .product-item:hover{
        cursor:pointer;
      }
      .product-item:nth-child(1) {
        background: linear-gradient(48deg, #78B943, #06A3CA);
      }

      .product-item:nth-child(2) {
        background: linear-gradient(48deg, #FDB52B, #FC5F74);
      }

      .product-item:nth-child(3) {
        background: linear-gradient(0deg, #3676FB 0%, #1561C9 100%);
      }

      .product-item:nth-child(4) {
        background: linear-gradient(48deg, #2CB3A4, #1B6F88);
      }

      .product-item:nth-child(5) {
        background: linear-gradient(48deg, #E0B3B1, #4547BC);
      }

      .product-item:nth-child(6) {
        background: linear-gradient(48deg, #DF410A, #EDB53B);
      }

    }
  }


  .tool-box {
    width: 100%;
    margin-top:90px;
    .title {
      position: relative;
      text-align: center;

      span {
        position: relative;
        left: -.62vw;
        font-size: 1.5vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 1.35416vw;
      }
    }

    .tool {
      width: 100%;
      height: 39.197916vw;
      background: url(./images/tool-bg.png) no-repeat center center;
      /* 背景保持原整行的绘制尺寸，内容框收进左右留白后仍与手机插画对位。 */
      background-size: calc(100% + 30vw) 100%;
      padding-top: 6.97916vw;
      margin-top: 60px;

      .text {
        width: 45%;
        margin-left: 55%;
        font-size: .9375vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 1.82291vw;
      }

      .img-btn {
        margin-left: 55%;
        margin-top: 1.614583vw;
        margin-bottom: 2.8125vw;

        .img {
          display: inline-block;
          width: 5.260416vw;
          height: 5.260416vw;
          margin-right: 1.14583vw;
          img{
            width: 100%;
            height: 100%;
          }
        }

        .btn {
          display: inline-block;
          width: 7.1875vw;
          height: 2.1875vw;
          background: #F5F6F8;
          border-radius: 1.14583vw;
          font-size: .9375vw;
          font-family: Microsoft YaHei;
          font-weight: 600;
          color: #068953;
          text-align: center;
          line-height: 2.1875vw;
          position: relative;
          top: -2.1875vw;
          background: #F5F6F8;

        }
        .btn:hover{
        cursor:pointer;
      }
      }
    }
  }




  .caseShare {
    /* 每行保留三个 1vw 间距，收缩与展开后的四张卡片仍正好铺满。 */
    --case-card-width: calc((100% - 3vw) / 4);
    --case-narrow-width: calc((100% - 3vw) / 5);
    --case-expanded-width: calc((200% - 6vw) / 5);
    margin: 0 auto;
    margin-top: 50px;

    .title {
      position: relative;
      text-align: center;

      span {
        position: relative;
        left: -.62vw;
        font-size: 1.5vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 1.35416vw;
      }
    }

    .caseShare-box {
      margin-top: 2.864583vw;
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .caseShare-item {
        width: var(--case-card-width);
        height: 15.67708vw;
        margin-bottom: .885416vw;
        position: relative;
        background-color: red;
        .case_bg {
          width: 100%;
          height: 100%;
          position: absolute;
          z-index: 1;
        }
        .case_icon {
          position: absolute;
          z-index: 10;
          top: 9.739583vw;
          left: 1.40625vw;
          width: 3.02083vw;
          height: 2.5vw;
        }
        .case-hover-icon {
          animation: iconMove 1s;
          animation-fill-mode:forwards

        }
        .case_naem{
          position: absolute;
          z-index: 10;
          color: #fff;
          font-size: .9375vw;
          left: 1.622916vw;
          bottom: 1.822916vw;
        }
        .case-hover-name {
          animation: nameMove 1s;
          animation-fill-mode:forwards
        }
        .bgc {
          position: absolute;
          z-index: 2;
          background-color: rgba(50, 121, 234, .7);
          width: 100%;
          height: 100%;
          .ledgement {
            width: 2.135416vw;
            height: .15625vw;
            background: #FFFFFF;
            position: absolute;
            left: 1.51875vw;
            top: 8.22916vw;
          }
          .type {
            width: calc(100% - 3.4375vw);
            margin-left: 1.71875vw;
            margin-top: 9.3875vw;
            line-height: 1.71875vw;
            color: #fff;
            font-size: .9375vw;
          }
          .case-hover-type {
            animation: typeMove 2s;
            animation-fill-mode:forwards;
            overflow: hidden;
            text-overflow: ellipsis;
            text-overflow: -webkit-ellipsis-lastline;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }
      .caseShare-item:hover{
        cursor:pointer;
      }
      .caseShare-item:nth-child(1){
        background-size: cover;
        
      }
      .caseShare-item:nth-child(2){
        background-size: cover;
      }
      .caseShare-item:nth-child(3){
        background-size: cover;
      }
      .caseShare-item:nth-child(4){
        background-size: cover;
      }
      .caseShare-item:nth-child(5){
        background-size: cover;
      }
      .caseShare-item:nth-child(6){
        background-size: cover;
      }
      .caseShare-item:nth-child(7){
        background-size: cover;
      }
      .caseShare-item:nth-child(8){
        background-size: cover;
      }
        @keyframes nameMove {
          0% {
            bottom: 1.822916vw;
          }
          100% {
            bottom: 8.489583vw;
          }
        }
        @keyframes iconMove  {
          0% {
            top: 9.739583vw;
          }
          100% {
            top: 3.17708vw;
          }
        }
        @keyframes typeMove  {
          0% {
            opacity: 0;
            // display: none;
          }
          100% {
            opacity: 1;
            // display: inline-block;
          }
        }
    }
  }



  .about {
    margin: 0 auto;
    margin-top:50px;
    padding-bottom: 7.02083vw;
    .title {
      position: relative;
      text-align: center;

      span {
        position: relative;
        left: -.62vw;
        font-size: 1.5vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 1.35416vw;
      }
    }

    .about-box {
      width: 100%;
      display: flex;
      gap: 4.40625vw;
      margin-top: 3.125vw;

      .about-img {
        width: 40%;
        flex-shrink: 0;
        height: 21.010416vw;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .about-list {
        flex: 1;
        min-width: 0;
        // flex: 1;
        // display: flex;
        // flex-wrap: wrap;
        // justify-content: space-between;

        .about-item {
          // width: 100%;
          height: 7.5vw;

          margin-bottom: .68vw;

          img {
            width: 1.25vw;
            height: 1.14583vw;
            margin-right: .572916vw;

          }

          .aboutTitle {
            font-size: 1.2vw;
    width: 100%;
    margin-top: 1vw;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
            font-size: 1vw;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;

          }
        }
      }
     
      .about-list:hover{
        cursor:pointer;
      }
    }
  }

  // 媒体查询
  @media screen and (min-width:600px) and (max-width:1200px) {

    .be_service ul li p,
    .list_box ul li h6,
    .news_case ol dl dd p {
      @include ellipsis;
      display: block;
    }

    .features .fuwutese_box .woman {
      top: 22%;
    }
  }
  #avoutId:hover {
        color: #00abfa;
      }
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue